import { useTranslation } from 'react-i18next';

import { ConfirmationModal } from '@/modules/common/components/modals/confirmation-modal';

interface TimeOffApplyChangesModalProps {
  open: boolean;
  onCancel: () => void;
  onConfirm: () => void | Promise<void>;
  isLoading: boolean;
}

export const TimeOffApplyChangesModal = ({
  open,
  onCancel,
  onConfirm,
  isLoading,
}: TimeOffApplyChangesModalProps) => {
  const { t } = useTranslation(['authenticated.settings', 'common']);

  return (
    <ConfirmationModal
      open={open}
      onClose={onCancel}
      title={t('authenticated.settings:pages.timeOff.details.applyChangesModal.title')}
      message={t('authenticated.settings:pages.timeOff.details.applyChangesModal.message')}
      confirmText={t('authenticated.settings:pages.timeOff.details.applyChangesModal.confirm')}
      cancelText={t('common:cancel')}
      confirmVariant="default"
      isLoading={isLoading}
      onConfirm={async closeModal => {
        await onConfirm();
        closeModal();
      }}
    />
  );
};
